import { render } from "./ExportImportComponents.vue?vue&type=template&id=34df9524"
import script from "./ExportImportComponents.vue?vue&type=script&lang=js"
export * from "./ExportImportComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__